function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as selectors from '../../../selectors';
import PatientProfileForm from './PatientProfileForm';
import ReauthorizeCloudDrive from './ReauthorizeCloudDrive';
var _React_PureComponent;
class PatientProfile extends (_React_PureComponent = React.PureComponent) {
    render() {
        if (!this.props.patientProfile) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6 pr-10",
                    children: /*#__PURE__*/ _jsx(PatientProfileForm, {
                        patientProfile: this.props.patientProfile
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6 pl-10",
                    children: /*#__PURE__*/ _jsx(ReauthorizeCloudDrive, {
                        patientProfile: this.props.patientProfile
                    })
                })
            ]
        });
    }
}
_define_property(PatientProfile, "propTypes", {
    // Implicit props
    patientProfile: PropTypes.object
});
const mapStateToProps = (state)=>({
        patientProfile: selectors.patientProfile(state)
    });
const ConnectedPatientProfile = connect(mapStateToProps)(PatientProfile);
export default ConnectedPatientProfile;
